<template>
    <div id="ambis-meter">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Ambis Test',
                    to: { path: '/ambis-test' },
                    exact: true,
                },
                { text: 'Skala' },
            ]"
            divider="|"
        ></v-breadcrumbs>
        <h3 class="header-text font-weight-bold">Skala</h3>

        <v-card flat class="mt-5">
            <v-card-text class="pa-8">
                <v-row>
                    <v-col md="2" class="font-weight-500">
                        Nama Tema Skala
                    </v-col>
                    <v-col md="10" class="font-weight-bold">
                        {{ theme.theme_name || "-" }}
                    </v-col>
                    <v-col md="2" class="font-weight-500 py-2">
                        Jenis User
                    </v-col>
                    <v-col md="10" class="py-2 font-weight-bold">
                        {{ theme.target_user || "-" }}
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-card class="mt-5">
            <v-card-title>
                Daftar Skala
                <v-spacer></v-spacer>
                <v-btn
                    class="align-center text-body-2 blew white--text"
                    depressed
                    @click="createScale()"
                >
                    <v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Tambah Skala
                </v-btn>
            </v-card-title>
            <v-divider />

            <app-datatable
                :items="row"
                :headers="headers"
                :has-action="true"
                :has-leaderboard="true"
                :key="tableKey"
                :customWidth="true"
                :has-custom-pagination="true"
                :has-custom-search="true"
                :custom-pagination-total-items="total_data"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="pagination.totalPages"
                :custom-pagination-sort-mode="pagination.sortMode"
                :row-expanded-detail="row"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="editScale()"
                v-on:deleted="confirmDeleteItem($event)"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: $event.key };
                    doSearch();
                "
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>

        <v-dialog v-model="confirmDialog" persistent max-width="480px">
            <v-card class="py-2">
                <v-card-title style="word-break: break-word !important">
                    Apakah anda akan menghapus Skala ini ?
                </v-card-title>
                <v-card-text>
                    Skala
                    <b>{{ selectedRow ? selectedRow.scale_name : "" }}</b> akan
                    dihapus.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="darkFade" text @click="confirmDialog = false">
                        Batal
                    </v-btn>
                    <v-btn
                        color="red"
                        dark
                        depressed
                        :loading="isLoadingForm"
                        @click="deleteItem()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import AmbisTestService from "@/modules/ambis_test/services/ambis_test.js";
import Moment from "moment";

export default {
    name: "ambis-test",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            isLoading: false,
            isLoadingForm: false,
            selectedRow: null,
            confirmDialog: false,
            search: "",
            total_data: 0,
            total_data_per_page: 10,
            tableKey: 0,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            params: {
                sortMode: "desc",
                scale_name: "",
                question_type: "",
                scale_status: "",
            },
            row: [],
            headers: [
                { text: "Nama Skala", value: "scale_name" },
                {
                    text: "Jenis Respon",
                    value: "question_type",
                    max_width: "5px",
                },
                { text: "Jumlah Pertanyaan", value: "total_question" },
                { text: "Status", value: "scale_status" },
                { text: "Aksi", value: "actions" },
            ],
            headersKey: ["name", "response", "questions", "status"],
            theme: {},
        };
    },

    watch: {
        pagination() {
            this.params.sortMode = this.pagination.sortMode;
            this.getListScale();
        },
    },

    async mounted() {
        await this.getDetailTheme();
        await this.getListScale();
    },

    methods: {
        getListScale: function () {
            var context = this;
            this.params.page = context.pagination.currentPage;
            this.params.size = context.pagination.perPage;

            const theme_id = this.$route.query.id;

            AmbisTestService.getListScale(theme_id, this.params, (result) => {
                context.row = [];

                if (result) {
                    context.total_data = result.data.total_data;
                    context.pagination.totalPages = result.data.max_page;

                    result.data.data.forEach(function (response, index) {
                        var row = {
                            no: index,
                            id: response.id,
                            theme_id: response.theme_id,
                            scale_name: response.scale_name,
                            scale_description: response.scale_description,
                            question_type:
                                context.theme.type !== "tryout"
                                    ? response.question_type
                                    : "tryout",
                            status: response.status,
                            total_question: response.total_question,
                        };

                        context.row.push(row);
                        context.row = _.orderBy(context.row, "id", "asc");
                        context.isLoading = false;
                    });
                }
                context.isLoading = false;
            });
        },

        doSearch() {
            this.params.page = 1;
            this.pagination.currentPage = 1;
            this.params[this.search.by.value] = this.search.query;

            this.getListScale();
        },

        createScale: function () {
            this.$router.push({
                path: "/form",
                query: {
                    theme_id: this.$route.query.id,
                },
            });
        },

        editScale: function () {
            this.$router.push({
                path: "/form",
                query: {
                    theme_id: this.$route.query.id,
                    scale_id: this.selectedRow.id,
                },
            });
        },

        confirmDeleteItem(val) {
            this.selectedRow = val;
            this.confirmDialog = true;
        },

        deleteItem() {
            var context = this;
            const id = context.selectedRow.id;

            context.isLoadingForm = true;

            AmbisTestService.deleteScale(id, function (result) {
                if (result.success) {
                    context.confirmDialog = false;
                    context.getListScale();
                    context.isLoadingForm = false;
                } else {
                    context.isLoadingForm = false;
                }
            });
        },

        getDetailTheme() {
            var context = this;
            const theme_id = context.$route.query.id;

            AmbisTestService.getDetailTheme(theme_id, function (result) {
                if (result.success) {
                    context.theme = result.data;
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// DetailSkala.vue?01a19436